export const en = {
  // Meta tags
  'meta.landing.title': 'Free QR Codes — No Expiry | QR Tool',
  'meta.landing.description': 'Create static and dynamic QR codes for free — no expiry, no ads. Scan statistics available for registered users.',
  'meta.builder.title': 'Create QR Code | QR Tool',
  'meta.builder.description': 'Link, Text, WiFi, WhatsApp, vCard, Instagram — create a QR code and download as SVG, PNG or JPG.',
  'meta.myCodes.title': 'My QR Codes | QR Tool',
  'meta.myCodes.description': 'Manage your dynamic QR codes, change target URLs and view scan statistics.',
  'meta.login.title': 'Sign in | QR Tool',
  'meta.login.description': 'Sign in or register for free dynamic QR codes with scan tracking.',

  // Landing page
  'landing.hero.title': 'QR Codes Without Expiry',
  'landing.hero.subtitle': 'Static or dynamic — free, forever, no tricks.',
  'landing.hero.cta': 'Create QR Code now',
  'landing.static.title': 'Static QR Code',
  'landing.static.desc': 'The target URL is stored directly inside the QR code. No account, no server — works anywhere, anytime.',
  'landing.static.feat1': 'No account needed',
  'landing.static.feat2': 'No expiry date',
  'landing.static.feat3': 'Works offline',
  'landing.static.feat4': 'URL cannot be changed later',
  'landing.dynamic.title': 'Dynamic QR Code',
  'landing.dynamic.desc': 'The QR code points to our redirect server. You can change the target URL at any time — without reprinting the QR code.',
  'landing.dynamic.feat1': 'Change target URL anytime',
  'landing.dynamic.feat2': 'Scan statistics (country, device, browser)',
  'landing.dynamic.feat3': 'No expiry date',
  'landing.dynamic.feat4': 'Free account required',
  'landing.dynamic.cta': 'Register for free',
  'landing.types.title': 'All Common QR Types',
  'landing.types.subtitle': 'Link, Text, WiFi, WhatsApp, vCard, Instagram — and more.',
  'landing.notice.title': 'No tricks. No expiry.',
  'landing.notice.text': 'This tool is freeware. If you want to support the developer, you are very welcome to.',
  'landing.notice.cta': 'Support the developer',

  // Auth
  'auth.login': 'Sign in',
  'auth.register': 'Sign up',
  'auth.logout': 'Sign out',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.username': 'Username',
  'auth.confirmPassword': 'Confirm password',
  'auth.forgotPassword': 'Forgot password?',
  'auth.resetPassword': 'Reset password',
  'auth.resetPasswordDesc': 'Enter your email address and we\'ll send you a reset link.',
  'auth.sendResetLink': 'Send link',
  'auth.resetLinkSent': 'A reset link has been sent to {{email}}.',
  'auth.backToLogin': 'Back to login',
  'auth.noAccount': 'No account yet?',
  'auth.hasAccount': 'Already have an account?',
  'auth.usernameAvailable': 'Available',
  'auth.usernameTaken': 'Taken',
  'auth.usernameInvalid': 'Letters and numbers only, max 10 characters',
  'auth.usernameChecking': 'Checking...',
  'auth.passwordMismatch': 'Passwords do not match',
  'auth.loginWithGoogle': 'Sign in with Google',
  'auth.orDivider': 'or',
  'auth.logoutMessage': 'You have been signed out.',

  // Account / Settings
  'account.title': 'My Account',
  'account.profile': 'Profile',
  'account.changeEmail': 'Change email',
  'account.changePassword': 'Change password',
  'account.changeAddress': 'Change address',
  'account.newEmail': 'New email',
  'account.currentPassword': 'Current password',
  'account.newPassword': 'New password',
  'account.confirmNewPassword': 'Confirm new password',
  'account.street': 'Street',
  'account.zip': 'ZIP code',
  'account.city': 'City',
  'account.country': 'Country',
  'account.save': 'Save',
  'account.saved': 'Saved!',
  'account.emailConfirmation': 'A confirmation email has been sent to {{email}}.',
  'account.passwordChanged': 'Password changed successfully.',
  'account.memberSince': 'Member since {{date}}',

  // Home
  'home.welcome': 'Welcome',
  'home.welcomeGuest': 'Welcome, Guest',
  'home.description': 'Create your QR code.',

  // QR Builder
  'qr.stepType': 'Choose type',
  'qr.stepContent': 'Enter content',
  'qr.stepDesign': 'Customize design',
  'qr.typeLink': 'Link',
  'qr.typeText': 'Text',
  'qr.typeEmail': 'E-mail',
  'qr.typeCall': 'Call',
  'qr.typeSms': 'SMS',
  'qr.typeVcard': 'V-Card',
  'qr.typeWhatsapp': 'WhatsApp',
  'qr.typeWifi': 'Wi-Fi',
  'qr.typeInstagram': 'Instagram',
  'qr.typePdf': 'PDF',
  'qr.typeApp': 'App',
  'qr.typeImages': 'Images',
  'qr.typeVideo': 'Video',
  'qr.typeSocial': 'Social Media',
  'qr.typeEvent': 'Event',
  'qr.typeBarcode': '2D Barcode',
  // Text form
  'qr.text.content': 'Enter text:',
  'qr.text.placeholder': 'Any text...',

  // WiFi form
  'qr.wifi.networkName': 'Network name (SSID)',
  'qr.wifi.encryption': 'Type of encryption',
  'qr.wifi.password': 'Password',
  'qr.wifi.hidden': 'Hidden network',
  'qr.wifi.encWpa': 'WPA/WPA2',
  'qr.wifi.encWep': 'WEP',
  'qr.wifi.encNone': 'No password',

  // WhatsApp form
  'qr.wa.countryCode': 'Country code',
  'qr.wa.phone': 'Phone number',
  'qr.wa.message': 'Message (optional)',

  // vCard form
  'qr.vcard.contactInfo': 'Contact Information',
  'qr.vcard.companyInfo': 'Company Information',
  'qr.vcard.location': 'Location',
  'qr.vcard.firstName': 'First name',
  'qr.vcard.lastName': 'Last name',
  'qr.vcard.phone': 'Phone number',
  'qr.vcard.mobile': 'Mobile',
  'qr.vcard.email': 'E-mail',
  'qr.vcard.website': 'Website (URL)',
  'qr.vcard.company': 'Company',
  'qr.vcard.jobTitle': 'Job title',
  'qr.vcard.fax': 'Fax',
  'qr.vcard.address': 'Address',
  'qr.vcard.city': 'City',
  'qr.vcard.zip': 'Post code',
  'qr.vcard.country': 'Country',

  // Instagram form
  'qr.insta.username': 'Instagram username',

  'qr.scanUrl': 'Opens when scanned:',
  'qr.createShortLink': 'Create short link',
  'qr.enterUrl': 'Enter your website:',
  'qr.urlPlaceholder': 'https://www.example.com',
  'qr.generate': 'Create QR code',
  'qr.download': 'Download',
  'qr.designFrame': 'Frame',
  'qr.designShape': 'Shape',
  'qr.designLogo': 'Logo',

  // Login page notice
  'login.noticeTitle': 'No tricks. No expiry.',
  'login.noticeText': 'This tool is freeware — no annoying ads, no automatic deactivation of your QR codes after a few days. If you\'d like to support the developer, you\'re very welcome to.',
  'login.noticeCta': 'Support the developer',

  // Navigation
  'nav.builder': 'Create QR Code',

  // Footer
  'footer.impressum': 'Legal Notice',
  'footer.kontakt': 'Contact',
  'footer.datenschutz': 'Privacy Policy',

  // My Codes
  'myCodes.title': 'My QR Codes',
  'myCodes.empty': 'No QR codes created yet.',
  'myCodes.scans': 'Scans',
  'myCodes.edit': 'Edit',
  'myCodes.delete': 'Delete',
  'myCodes.confirmDelete': 'Really delete?',
  'myCodes.titlePlaceholder': 'Title (optional)',
  'myCodes.back': 'Back',

  // General
  'general.loading': 'Loading...',
  'general.error': 'Error',
  'general.success': 'Success',
  'general.cancel': 'Cancel',
} as const
